import { http } from "../client";
export var pauseDevice = function (id) { return http.api.post("devices/" + id + "/stop"); };
